import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import HotTopics from './components/HotTopics';
import DailyContest from './components/DailyContest';
import GossipWall from './components/GossipWall';
import DownloadCTA from './components/DownloadCTA';

export default function Home() {
  return (
    <>
      <SEO
        title="吃瓜网每日大赛 | 官网入口与APP下载 | 网红大瓜黑料每日更新"
        description="吃瓜网每日大赛官网入口与APP下载中心，专注每日吃瓜爆料、网红塌房与黑料大瓜。作为吃瓜爆料核心门面，实时追踪网络热门事件，随时看最新猛料。"
        keywords="吃瓜网每日大赛,吃瓜网每日大赛入口,吃瓜网每日大赛app,吃瓜网每日大赛下载,吃瓜网每日大赛官网,吃瓜爆料,网红黑料,每日大赛,实时追踪,最新地址,娱乐吃瓜"
        canonicalUrl="http://irilpt.cn/"
        schemaType="WebPage"
        breadcrumbs={[{ name: '首页', url: 'http://irilpt.cn/' }]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotTopics />
        <DailyContest />
        <GossipWall />
        <DownloadCTA />
      </main>
      <Footer />
    </>
  );
}